import _ from "lodash";
import {
    FACEBOOK_SEARCH_TARGETING_LOCATION_TYPES,
    FACEBOOK_SEARCH_TARGETING_LOCATION_TYPES_LIST,
    FACEBOOK_SEARCH_TARGETING_TYPE_LIST, FACEBOOK_SEARCH_TARGETING_TYPES
} from "./facebook-constant";

export const TARGETING_FIELDS_LIST: any = [
    {attribute: "type", label: "Type", cssClass: ''},
    {attribute: "query", label: "Query", cssClass: ''},
];


export const SEARCH_TARGETING_INPUT_FIELDS: any = [
    {
        attribute: "type",
        label: "Type",
        type: 'select',
        readOnly: false,
        group: 'detail',
        options: FACEBOOK_SEARCH_TARGETING_TYPE_LIST,
        default: FACEBOOK_SEARCH_TARGETING_TYPES.LOCATION,
        cssClass: 'w-1/5'
    },
    {
        attribute: "location_type",
        label: "Location Type",
        type: 'select',
        readOnly: false,
        group: 'detail',
        options: FACEBOOK_SEARCH_TARGETING_LOCATION_TYPES_LIST,
        default: FACEBOOK_SEARCH_TARGETING_LOCATION_TYPES.COUNTRY,
        cssClass: 'w-1/5',
        showWhen: {
            attribute: 'type',
            values: [FACEBOOK_SEARCH_TARGETING_TYPES.LOCATION]
        }
    },
    {attribute: "query", label: "Query", type: 'text', group: 'detail', cssClass: 'w-2/5'},
];


